import React from 'react';
import PropTypes from 'prop-types';

export function PersonIcon({
    width = 32,
    height = 24,
    fill = 'currentColor',
    className,
    idSuffix = '',
    ...rest
}) {
    const clipId = `personIconClip${idSuffix}`;
    // long path - keep on single line to avoid modifying SVG path data
    // eslint-disable-next-line max-len
    const pathD = 'M15.8413 7.78827C17.3725 7.78827 18.6133 9.02907 18.6133 10.5603C18.6133 12.0915 17.3725 13.3323 15.8413 13.3323C14.3101 13.3323 13.0692 12.0915 13.0692 10.5603C13.0692 9.02907 14.3101 7.78827 15.8413 7.78827ZM15.8413 19.6683C19.7617 19.6683 23.8933 21.5955 23.8933 22.4403V23.8923H7.78925V22.4403C7.78925 21.5955 11.9209 19.6683 15.8413 19.6683ZM15.8413 5.28027C12.9241 5.28027 10.5613 7.64307 10.5613 10.5603C10.5613 13.4775 12.9241 15.8403 15.8413 15.8403C18.7585 15.8403 21.1213 13.4775 21.1213 10.5603C21.1213 7.64307 18.7585 5.28027 15.8413 5.28027ZM15.8413 17.1603C12.3169 17.1603 5.28125 18.9291 5.28125 22.4403V26.4003H26.4013V22.4403C26.4013 18.9291 19.3657 17.1603 15.8413 17.1603Z';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 32 24"
            fill="none"
            className={className}
            color='inherit'
            aria-hidden={rest['aria-label'] ? 'false' : 'true'}
            {...rest}
        >
            <g clipPath={`url(#${clipId})`}>
                <path d={pathD} fill={fill} />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="31.68" height="23.76" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default PersonIcon;

PersonIcon.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fill: PropTypes.string,
    className: PropTypes.string,
    idSuffix: PropTypes.string
};

PersonIcon.defaultProps = {
    width: 32,
    height: 24,
    fill: 'currentColor',
    className: undefined,
    idSuffix: ''
};
